import { ServicePointController } from "./controller";
import { VStack } from "@gluestack-ui/themed";

import { SelectServicePointsList } from "@repo/core/components/layout/SelectServicePointsList";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

export const ServicePoint = () => {
  const {
    back,
    handleOnSubmitForm,
    selectedServicePointId,
    servicePoints,
    handleSelectServicePoint,
    isFetchingServicePoints
  } = ServicePointController();

  return (
    <PageScaffold
      onBackPress={back}
      onPressRightIcon={back}
      rightWebLabel="Fechar"
      title="Ponto de Atendimento"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryIsDisabled={!selectedServicePointId}
          primaryOnPress={handleOnSubmitForm}
          secondaryText="Cancelar"
          secondaryOnPress={back}
        />
      }
    >
      <VStack w="$full">
        <SelectServicePointsList
          servicePoints={servicePoints}
          selectedServicePoint={selectedServicePointId}
          onSelectServicePoint={handleSelectServicePoint}
          isLoading={isFetchingServicePoints}
        />
      </VStack>
    </PageScaffold>
  );
};
